/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface S3UploadFile {
    uploadedFilesObject: {
        [key: string]: Array<string>;
    };
    isLoading: boolean;
}

const initialHeaderState: S3UploadFile = {
    uploadedFilesObject: {},
    isLoading: false,
};

const reducer = {
    "xRequestRma/S3UploadFileRequest": (
        draft: Draft<S3UploadFile>,
        action: {
            uploadedFiles: string;
            lineNumber: number;
            isLoading: boolean;
        },
    ) => {

        draft.isLoading = action.isLoading
        if (action.uploadedFiles && action.uploadedFiles.length) {
            if (!draft.uploadedFilesObject[action.lineNumber]) {
                draft.uploadedFilesObject[action.lineNumber] = [action.uploadedFiles]
            } else {
                draft.uploadedFilesObject[action.lineNumber].push(action.uploadedFiles)
            }
        }
    },
    "xRequestRma/S3UploadFileClear": (
        draft: Draft<S3UploadFile>,
    ) => {
        draft.isLoading = false;
        draft.uploadedFilesObject = {}
    },
};

const xS3UploadFile = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).xS3UploadFile = xS3UploadFile;

export type xS3UploadFileState = {
    xS3UploadFile: S3UploadFile;
};

type xS3UploadFileReducers = {
    uploadedFilesObject: typeof xS3UploadFile;
};

export type xS3UploadFilerActions = Parameters<xS3UploadFileReducers[keyof xS3UploadFileReducers]>[1] | AnyAction;
